import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { Location } from '@angular/common';
import { ToasterService } from 'angular2-toaster';
import { Subscription } from 'rxjs';
import { take, switchMap, delay, catchError, concatMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { of } from 'rxjs/observable/of';

import { ShareProjectService } from '../../../services/share-project.service';
import { LoadingSpinnerService } from '../../../services/loading-spinner.service';
import { AuthService } from '../../../services/auth.service';
import { ProjectManagerService } from '../../../services/project-manager.service';
import { environment } from '../../../../environments/environment';
import { ProjectSaveService } from '../../../services/project-save.service';
import { ModalResetPasswordComponent } from '../modal-reset-password/modal-reset-password.component';

@Component({
  selector: 'app-modal-contact',
  templateUrl: './modal-contact.component.html',
  styleUrls: ['./modal-contact.component.scss']
})
export class ModalContactComponent {
  appUrl: string = environment.appUrl;
  logingRerquirementDialogOpen = false;
  loginDialogOpen = false;
  registrationDialogOpen = false;
  contactFormDialogOpen = false;
  dialogRefAfterClosedSubscription: Subscription;
  contactForm: any = {
    name: '',
    surname: '',
    company: '',
    email: '',
    phone: '',
    comments: '',
    agreed: true
  };

  constructor(
    private dialogRef: MatDialogRef<ModalContactComponent>,
    private shareProjectService: ShareProjectService,
    private dialog: MatDialog,
    private authService: AuthService,
    private projectManagerService: ProjectManagerService,
    private toasterService: ToasterService,
    private loadingSpinnerService: LoadingSpinnerService,
    private saveProjectService: ProjectSaveService,
    private location: Location
  ) {}

  private _updateContactForm() {
    const { email, firstName, lastName, phone } = this.authService.getUser();
    const { projectName, id } = this.projectManagerService.getCurrentProject();
    this.contactForm.email = email || '';
    this.contactForm.name = firstName || '';
    this.contactForm.surname = lastName || '';
    this.contactForm.phone = phone || '';
    this.contactForm.projectName = projectName;
    this.contactForm.projectId = id;
    this.contactForm.projectUrl = `${this.appUrl}/browsing/${id}`;
  }

  private _showToast(type: string, title: string, body: string) {
    this.toasterService.popAsync(type, title, body);
  }

  private _getProjectName() {
    if (
      this.projectManagerService.project.projectName &&
      !this.projectManagerService.ifCurrentProjIsSharedProj(this.projectManagerService.project.id)
    ) {
      return of(this.projectManagerService.project.projectName);
    } else {
      return this.projectManagerService.getNewProjectName();
    }
  }

  private _saveProject(exists: boolean) {
    let saveAsNewProject = false;
    this.loadingSpinnerService.spinnerLoadingListAdd('saveProjectInModalContactComponent');
    if (
      this.projectManagerService.ifCurrentProjIsSharedProj(
        this.projectManagerService.getCurrentProjectId()
      ) ||
      !this.projectManagerService.project.id ||
      (this.projectManagerService.project.id && !exists)
    ) {
      saveAsNewProject = true;
    }

    if (this.projectManagerService.ifCurrentProjIsSharedProj(this.projectManagerService.project.id))
      this.location.replaceState('');

    // get project unique name...
    return this._getProjectName().pipe(
      concatMap(projectName => {
        console.log('projectName', projectName);
        return this.saveProjectService.save(projectName, saveAsNewProject);
      }),
      concatMap(() => {
        this.loadingSpinnerService.spinnerLoadingListRemove('saveProjectInModalContactComponent');
        this.dialogRef.updateSize('508px', 'auto');
        this.contactFormDialogOpen = true;
        this._updateContactForm();
        return of(true);
      }),
      catchError(err => {
        this.loadingSpinnerService.spinnerLoadingListRemove('saveProjectInModalContactComponent');
        this.contactFormDialogOpen = false;
        this._showToast('error', 'Error', 'Cannot open save project. Please try later');
        this.closeDialog();
        return of('Cannot save new project, please try later');
      })
    );
  }

  private _saveProjectAfterAuthorization() {
    combineLatest(
      this.authService.isAuthorization,
      this.projectManagerService.projectExists(this.projectManagerService.project.id)
    )
      .pipe(
        take(1),
        delay(0),
        switchMap(([authorized, { exists }]) => {
          this.logingRerquirementDialogOpen = !authorized;
          if (authorized) {
            return this._saveProject(exists);
          } else {
            return of();
          }
        })
      )
      .subscribe();
  }

  ngOnInit() {
    const project = this.projectManagerService.project;
    // console.log('project in contact', project);
    this._saveProjectAfterAuthorization();
    this.dialogRefAfterClosedSubscription = this.dialogRef.afterClosed().subscribe(() => {
      this.contactFormDialogOpen = false;
    });
  }

  login() {
    this.logingRerquirementDialogOpen = false;
    this.loginDialogOpen = true;
    this.dialogRef.updateSize('835px', '75vh');
  }

  onResetPasswordDialog() {
    this.loginDialogOpen = false;
    const dialogRef = this.dialog.open(ModalResetPasswordComponent, {
      width: '400px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Reset password dialog was closed');
    });
  }

  onLoginSuccess(token) {
    this.loginDialogOpen = false;
    this.dialogRef.updateSize('508px', 'auto');
    this.contactFormDialogOpen = true;
    this._saveProjectAfterAuthorization();
  }

  onCreateANewAccount() {
    this.loginDialogOpen = false;
    this.registrationDialogOpen = true;
  }

  onUserUpdate() {}

  onUserRegister() {
    this.registrationDialogOpen = false;
    this.loginDialogOpen = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  checkAgreement(agr) {
    // console.log(agr);
  }

  sendContact() {
    // console.log(this.contactForm);
    this.shareProjectService.shareContact(this.contactForm).subscribe(
      res => {
        this.loadingSpinnerService.spinnerLoadingListRemove('contactMe');
        this.showToast('success', 'Success', 'Help requested');
        // console.log(res);
      },
      err => {
        this.loadingSpinnerService.spinnerLoadingListRemove('contactMe');
        this.showToast('error', 'Error', 'Something went wrong');
      }
    );
  }

  showToast(type: string, title: string, body: string): void {
    this.toasterService.popAsync(type, title, body);
  }

  ngOnDestroy() {
    if (this.dialogRefAfterClosedSubscription) this.dialogRefAfterClosedSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-contact/modal-contact.component.ts